export default function ContactForm() {
  return (
    <>
      <section className="demo py-10 xl:py-20">
        <div className="max-width">
          <article>
            <h2 className="text-white">Send us a message</h2>
            <p className="text-gray-200 text-center mb-10 mt-2">
              We'll get back to you within 24 hours
            </p>

            <form className="lg:max-w-5xl lg:mx-auto px-5 2xl:px-0 flex flex-col lg:w-1/2">
              <div className="grid grid-cols-2 gap-5">
                <input
                  type="text"
                  name="firstName"
                  id="firstName"
                  placeholder="First name"
                  required
                  className="py-3 px-5 bg-transparent placeholder-white input-border mb-10"
                />
                <input
                  type="text"
                  name="lastName"
                  id="lastName"
                  placeholder="Last name"
                  required
                  className="py-3 px-5 bg-transparent placeholder-white input-border mb-10"
                />
              </div>
              <input
                type="email"
                name="email"
                id="email"
                placeholder="Email"
                required
                className="py-3 px-5 bg-transparent placeholder-white input-border mb-10"
              />
              <textarea
                name="textarea"
                id="textarea"
                cols="30"
                rows="5"
                placeholder="Enter your message"
                required
                className="py-3 px-5 bg-transparent placeholder-white input-border mb-10"
              ></textarea>
              <button className="btn-light">Send message</button>
            </form>
          </article>
        </div>
      </section>
    </>
  )
}
